import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryCard.css";
import { getOptimizedUrl } from "../../../constants/globalFunction";

const CategoryCard = ({ category }) => {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate(`/category?category_id=${category?._id}`, {
      state: { category: category },
    });
  };

  return (
    <div
      className="shop-category-card"
      onClick={handlePress}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handlePress();
        }
      }}
    >
      <div className="shop-category-card__circle">
        {category?.image ? (
          <img
            src={getOptimizedUrl(category?.image)}
            alt={category?.name}
            className="shop-category-card__image"
            loading="lazy"
          />
        ) : (
          <div className="shop-category-card__placeholder">
            <span>{category?.name?.charAt(0)?.toUpperCase() || "?"}</span>
          </div>
        )}
      </div>

      <div className="shop-category-card__content">
        <h3 className="shop-category-card__title">{category?.name}</h3>
      </div>
    </div>
  );
};

export default CategoryCard;
